// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Style.css

.login-container {
    max-width: 400px;
    margin: auto;
    padding: 20px;
    text-align: center;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .login-form {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
  }
  
  label {
    margin-bottom: 8px;
  }
  
  input {
    padding: 8px;
    margin-bottom: 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  
  button {
    padding: 10px;
    background-color: #4caf50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  button:hover {
    background-color: #45a049;
  }
  
  p {
    margin-top: 16px;
  }
  
  Link {
    color: #3498db;
  }
   */`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAiDI","sourcesContent":["/* Style.css\n\n.login-container {\n    max-width: 400px;\n    margin: auto;\n    padding: 20px;\n    text-align: center;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .login-form {\n    display: flex;\n    flex-direction: column;\n    margin-top: 20px;\n  }\n  \n  label {\n    margin-bottom: 8px;\n  }\n  \n  input {\n    padding: 8px;\n    margin-bottom: 16px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n  }\n  \n  button {\n    padding: 10px;\n    background-color: #4caf50;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  button:hover {\n    background-color: #45a049;\n  }\n  \n  p {\n    margin-top: 16px;\n  }\n  \n  Link {\n    color: #3498db;\n  }\n   */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
